import React, { Component } from "react";
import TagActions from "../../../actions/TagActions";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import AppUtils from "../../../utils/AppUtils";

class AddStateTag extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tag: {
        TagDispName: "",
        DBArchive: "0",
        TagName: "",
        TagStates: [
          {
            StateValue: "0",
            StateName: "",
            StateDispName: "",
          },
        ],
      },
      t: {
        TagVisible: "",
        PlotMaxValue: "",
        TagDispName: "",
        TagUnit: "-",
        TypeDesc: "",
        PlotMinValue: "",
        RejMinValue: "",
        TagDesc: "",
        PlotColor: "",
        TypeType: "",
        RejMaxValue: "",
        DBArchive: "",
        TagName: "",
        TagOffset: "",
        Precision: "",
        PlotLogScale: "",
        TypeUnitFactor: "",
        TypeUnit: "",
        TagStates: [],
      },
      validateName: false,
      validateShortName: false,
      validateStates: false,
      checkbox:false,
    };
    this.checkTagName = this.checkTagName.bind(this);
    this.checkTagShortName = this.checkTagShortName.bind(this);
    this.insertTag = this.insertTag.bind(this);
    this.updateState = this.updateState.bind(this);
    this.addNewState = this.addNewState.bind(this);
    this.createNotification = this.createNotification.bind(this);
  }

  checkTagName() {
    try {
      const tagName = this.state.tag.TagName;
      const pattern = "[A-Za-z]{1,32}";
      let isFieldValid = false;
      if (tagName.trim() !== "") {
        if (tagName.match(pattern)) {
          isFieldValid = true;
          this.setState({ validateName: true });
          document.getElementById("TagName").className =
            "form-control form-control-sm mb-5";
          document.getElementById("tagNameError").style.display = "none";
        } else {
          document.getElementById("TagName").className =
            "form-control form-control-sm mb-5 border border-danger";
          document.getElementById("tagNameError").style.display = "block";
          document.getElementById("tagNameError").innerHTML =
            " Invalidate Tag Name.";
          isFieldValid = false;
          this.setState({ validateName: false });
        }
      } else {
        document.getElementById("TagName").className =
          "form-control form-control-sm mb-5 border border-danger";
        document.getElementById("tagNameError").style.display = "block";
        document.getElementById("tagNameError").innerHTML =
          " Tag Name can not be empty.";
        isFieldValid = false;
        this.setState({ validateName: false });
      }
      return isFieldValid;
    } catch (e) {
      console.log("checkTagName function in AddTag ", e);
    }
  }

  checkTagShortName() {
    try {
      const tagShortName = this.state.tag.TagDispName;
      const pattern = "[A-Za-z]{1,32}";
      let isFieldValid = false;
      if (tagShortName.trim() !== "") {
        if (tagShortName.match(pattern)) {
          isFieldValid = true;
          this.setState({ validateShortName: true });
          document.getElementById("TagDispName").className =
            "form-control form-control-sm mb-5";
          document.getElementById("tagShortNameError").style.display = "none";
        } else {
          document.getElementById("TagDispName").className =
            "form-control form-control-sm mb-5 border border-danger";
          document.getElementById("tagShortNameError").style.display = "block";
          document.getElementById("tagShortNameError").innerHTML =
            " Invalidate Display name.";
          isFieldValid = false;
          this.setState({ validateShortName: false });
        }
      } else {
        document.getElementById("TagDispName").className =
          "form-control form-control-sm mb-5 border border-danger";
        document.getElementById("tagShortNameError").style.display = "block";
        document.getElementById("tagShortNameError").innerHTML =
          "Display Name can not be empty.";
        isFieldValid = false;
        this.setState({ validateShortName: false });
      }
      return isFieldValid;
    } catch (e) {
      console.log("checkTagShortName function in AddTag ", e);
    }
  }

  checkStates() {
    let statesValid = true;
    try {
      let tagStates = this.state.tag.TagStates;
      if (tagStates.length === 1) {
        if (tagStates[0].StateName.trim(" ").length === 0) {
          statesValid = false;
          this.createNotification("StateNameEmpty");
        }
        if (tagStates[0].StateDispName.trim(" ").length === 0) {
          statesValid = false;
          this.createNotification("StateDispNameEmpty");
        }
        if (tagStates[0].StateValue.trim(" ").length === 0) {
          statesValid = false;
          this.createNotification("StateValueEmpty");
        }
      } else {
        for (let i = 0; i < tagStates.length - 1; i++) {
          if (statesValid === false) {
            break;
          }
          for (let j = i + 1; j < tagStates.length; j++) {
            if (tagStates[i].StateValue === tagStates[j].StateValue) {
              statesValid = false;
              this.createNotification("duplicateStateValue");
              break;
            }
            if (
              tagStates[i].StateValue.trim(" ").length === 0 ||
              tagStates[j].StateValue.trim(" ").length === 0
            ) {
              statesValid = false;
              this.createNotification("StateValueEmpty");
              break;
            }

            if (tagStates[i].StateDispName === tagStates[j].StateDispName) {
              statesValid = false;
              this.createNotification("duplicateStateDispName");
              break;
            }
            if (tagStates[i].StateName === tagStates[j].StateName) {
              statesValid = false;
              this.createNotification("duplicateStateName");
              break;
            }
            if (
              tagStates[i].StateDispName.trim(" ").length === 0 ||
              tagStates[j].StateDispName.trim(" ").length === 0
            ) {
              statesValid = false;
              this.createNotification("StateDispNameEmpty");
              break;
            }
            if (
              tagStates[i].StateName.trim(" ").length === 0 ||
              tagStates[j].StateName.trim(" ").length === 0
            ) {
              statesValid = false;
              this.createNotification("StateNameEmpty");
              break;
            }
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
    return statesValid;
  }

  prepareTagPayload() {
    let payload = {
      TagVisible: "1",
      PlotMaxValue: "1900",
      TagUnit: "-",
      PlotMinValue: "0",
      RejMinValue: "0",
      PlotColor: "0,0,0",
      TypeType: "500",
      RejMaxValue: "2000",
      TagOffset: "0",
      Precision: "2",
      PlotLogScale: "1",
      TypeUnitFactor: "1",
      TypeUnit: "-",
    };
    try {
      const statesArray = [];
      this.state.tag.TagStates.forEach((st) => {
        statesArray.push([
          st.StateValue.toString(),
          st.StateName,
          st.StateDispName,
        ]);
      });
      const AllStates = AppUtils.convertArrayToString(statesArray);
      payload = {
        ...payload,
        TagName: this.state.tag.TagName.trim(),
        TagDispName: this.state.tag.TagDispName.trim(),
        TypeDesc: this.state.tag.TagName.trim(),
        TagDesc: this.state.tag.TagName.trim(),
        DBArchive: this.state.checkbox ? "1" :"0",
        AllStates,
      };
    } catch (e) {
      console.log(e);
    }
    return payload;
  }

  insertTag(event) {
    try {
      event.preventDefault();
      const [validTagName, validTagShortName, validStates] = [
        this.checkTagName(),
        this.checkTagShortName(),
        this.checkStates(),
      ];
      if (validTagName && validTagShortName && validStates) {
        const tag = this.prepareTagPayload();
        TagActions.insertStateTag(tag);
        this.props.hideModal();
      } 
    } catch (e) {
      console.log("insertTag function in AddTag ", e);
    }
  }

  updateState(event, index) {
    try {
      const field = event.target.id;
      const value = event.target.value;
      const name = event.target.name;
      if (["StateName", "StateDispName", "StateValue"].includes(name)) {
        let tagStates = this.state.tag.TagStates;
        tagStates[index] = {
          ...tagStates[index],
          [name]: value,
        };
        this.setState({
          tag: {
            ...this.state.tag,
            TagStates: tagStates,
          },
        });
      } else {
        if (this.props.isMlTag && field === "TagName") {
          if (value.length >= 3) {
            let t = this.state.tag;
            t[field] = value;
            this.setState({ tag: t });
          }
        } else {
          let t = this.state.tag;
          t[field] = value;
          this.setState({ tag: t });
        }
      }
    } catch (e) {
      console.log("updateState function in AddTag ", e);
    }
  }

  addNewState() {
    try {
      let newTagStates = [
        ...this.state.tag.TagStates,
        {
          StateValue: "0",
          StateName: "",
          StateDispName: "",
        },
      ];
      this.setState({
        tag: {
          ...this.state.tag,
          TagStates: newTagStates,
        },
      });
    } catch (e) {
      console.log(e);
    }
  }

  removeState(index) {
    try {
      const oldStates = [...this.state.tag.TagStates];
      if (index >= 0 && index < oldStates.length) {
        oldStates.splice(index, 1);
        this.setState({
          tag: {
            ...this.state.tag,
            TagStates: [...oldStates],
          },
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  createNotification(type) {
    switch (type) {
      case "success":
        return NotificationManager.success(
          "Tag Added Successfuly",
          "Tag Added",
          2000
        );
      case "invalidTagName":
        return NotificationManager.warning(
          "Please Enter a Valid Tag Name",
          "WARNING MESSAGE",
          3000
        );
      case "invalidTagDispName":
        return NotificationManager.warning(
          "Please Enter a Valid Tag Display Name",
          "WARNING MESSAGE",
          3000
        );
      case "StateNameEmpty":
        return NotificationManager.warning(
          "State Name Cannot be Empty , Please Enter a Valid State Name",
          "WARNING MESSAGE",
          3000
        );
      case "StateDispNameEmpty":
        return NotificationManager.warning(
          "State Display Name Cannot be Empty , Please Enter a Valid State Display Name",
          "WARNING MESSAGE",
          3000
        );
      case "duplicateStateName":
        return NotificationManager.warning(
          "State Name Cannot be Duplicated , Please Enter Diffrent State Name",
          "WARNING MESSAGE",
          3000
        );
      case "duplicateStateDispName":
        return NotificationManager.warning(
          "State Display Name Cannot be Duplicated , Please Enter Diffrent State Display Name",
          "WARNING MESSAGE",
          3000
        );
      case "duplicateStateValue":
        return NotificationManager.warning(
          "State Value Cannot be Duplicated , Please Enter Diffrent State Value",
          "WARNING MESSAGE",
          3000
        );
        case "StateValueEmpty":
        return NotificationManager.warning(
          "State Value Cannot be Empty , Please Enter A Valid State Value",
          "WARNING MESSAGE",
          3000
        );
      default:
        break;
    }
  }

  render() {
    return (
      <form className="">
        <div className="row mt-10">
          <div className="col-sm-12">
            <div className="row">
              <fieldset
                id="state_tags_info_fieldset"
                className="mx-4"
                style={{ width: "100%" }}
              >
                <legend style={{ width: "auto", fontSize: "14px" }}>
                  Tag Info
                </legend>
                <div className="row">
                  <div className="col-sm-6">
                    <label
                      className="control-label col-sm-12"
                      htmlFor="TagName"
                    >
                      Tag Name : <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-12">
                      <input
                        onChange={(event) => {
                          this.updateState(event);
                          this.checkTagName();
                        }}
                        value={this.state.tag.TagName}
                        type="text"
                        className="form-control form-control-sm mb-5"
                        id="TagName"
                        pattern="[A-Za-z]{1,32}"
                        autoFocus
                        maxLength={"100"}
                      />
                      <div
                        id="tagNameError"
                        style={{ display: "none" }}
                        className="invalid-feedback"
                      ></div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <label
                      className="control-label col-sm-12"
                      htmlFor="TagDispName"
                    >
                      Display Name : <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-12">
                      <input
                        onChange={(event) => {
                          this.updateState(event);
                          this.checkTagShortName();
                        }}
                        type="text"
                        className="form-control form-control-sm mb-5"
                        id="TagDispName"
                        pattern="[A-Za-z]{1,32}"
                        maxLength={"100"}
                        value={this.state.tag.TagDispName}
                      />
                      <div
                        id="tagShortNameError"
                        style={{ display: "none" }}
                        className="invalid-feedback"
                      ></div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div className="col-sm-12">
            <div className="row mt-2">
              <fieldset
                id="state_tags_states_fieldset"
                className="mx-4"
                style={{ width: "100%",maxHeight:"60vh",overflowX:"hidden",overflowY:'scroll' }}
              >
                <legend style={{ width: "auto", fontSize: "14px" }}>
                  Tag States
                </legend>
                {this.state.tag.TagStates.map((stTag, index) => {
                  return (
                    <div key={"state" + index} className="mb-2">
                      <div className="row">
                        <div className="row col-sm-11 ">
                          <div className="col-sm-4">
                            <label
                              className="control-label col-sm-12"
                            >
                              Value : <span className="text-danger">*</span>
                            </label>
                            <div className="col-sm-12">
                              <input
                                onChange={(event) => {
                                  this.updateState(event, index);
                                  // this.checkTagName();
                                }}
                                value={
                                  this.state.tag.TagStates[index].StateValue
                                }
                                type="number"
                                className="form-control form-control-sm mb-5"
                                name="StateValue"
                                autoFocus
                              />
                              <div
                                id="StateValueError"
                                style={{ display: "none" }}
                                className="invalid-feedback"
                              ></div>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <label
                              className="control-label col-sm-12"
                            >
                              Name : <span className="text-danger">*</span>
                            </label>
                            <div className="col-sm-12">
                              <input
                                onChange={(event) => {
                                  this.updateState(event, index);
                                }}
                                value={
                                  this.state.tag.TagStates[index].StateName
                                }
                                type="text"
                                className="form-control form-control-sm mb-5"
                                name="StateName"
                                pattern="[A-Za-z]{1,32}"
                                maxLength={"100"}
                              />
                              <div
                                id="StateNameError"
                                style={{ display: "none" }}
                                className="invalid-feedback"
                              ></div>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <label
                              className="control-label col-sm-12"
                              htmlFor="TagDispName"
                            >
                              Display Name :
                              <span className="text-danger">*</span>
                            </label>
                            <div className="col-sm-12">
                              <input
                                onChange={(event) => {
                                  this.updateState(event, index);
                                }}
                                value={
                                  this.state.tag.TagStates[index].StateDispName
                                }
                                type="text"
                                className="form-control form-control-sm mb-5"
                                name="StateDispName"
                                pattern="[A-Za-z]{1,32}"
                                maxLength={"100"}
                              />
                              <div
                                id="StateDispName"
                                style={{ display: "none" }}
                                className="invalid-feedback"
                              ></div>
                            </div>
                          </div>
                        </div>
                        {index !== 0 && (
                          <div className="col-sm-1">
                            <div
                              className="col-sm-12 control-label"
                              style={{ height: "2rem" }}
                            ></div>
                            <button
                              className="btn btn-xs btn-danger"
                              title="Remove State"
                              onClick={(e) => {
                                e.preventDefault();
                                this.removeState(index);
                              }}
                            >
                              <i className="fa fa-trash-o" />
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
                <div className="mx-4 mt-2">
                  <span className="default-link" onClick={this.addNewState}>
                    + Add State
                  </span>
                </div>
              </fieldset>
            </div>
          </div>

          <div className="row mx-4 mt-2" hidden={this.props.isMlTag}>
            <div className=" form-check pl-1 pl-15">
              <input
                type="checkbox"
                hidden="true"
                className="form-check-input"
                id="DBArchive"
                checked={this.state.checkbox}
                onChange={() => {
                  this.setState({
                    checkbox: !this.state.checkbox,
                  });
                }}
              />
              <label className="form-check-label" htmlFor="DBArchive">
                Archive
              </label>
            </div>
          </div>
        </div>
        <div className="row ">
          <div className="col-sm-offset-2 col-sm-12">
            <button
              onClick={(event) => {
                this.insertTag(event);
              }}
              className="btn btn-sm btn-primary mt-5 float-right"
            >
              Save
            </button>
          </div>
          <NotificationContainer />
        </div>
      </form>
    );
  }
}

export default AddStateTag;
